import {
  Badge,
  Box,
  Button,
  Card,
  Group,
  Stack,
  Text,
} from '@mantine/core';
import { IconCalendar, IconClock, IconLock, IconGridDots, IconArrowRight, } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { formatDate } from '../../utils/dateUtils';

const ProcessCard = ({ process, onSelect, isHistorical = false }) => {
  
  const orderedStages = process.etapas?.sort((a, b) => a.orden - b.orden) ?? [];

  const startDate = orderedStages.length > 0 ? orderedStages[0].fechaInicio : null;
  const endDate = orderedStages.length > 0 ? orderedStages[orderedStages.length - 1].fechaCierre : null;
  const now = dayjs();

  let actualStage = orderedStages.find(e => e.activa);
  if (!actualStage) {
    // Si no hay ninguna activa, busca la etapa en curso por fecha
    actualStage = orderedStages.find(e =>
      dayjs(e.fechaInicio).isBefore(now) && dayjs(e.fechaCierre).isAfter(now)
    );
  }

  return (
    <Card withBorder radius="md" className='scale-hover' bg={isHistorical ? 'transparent' : ''} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Stack spacing="xs" style={{ flex: 1 }}>
        <Group justify='space-between' wrap='nowrap'>
          <div style={{ flex: 1 }}>
            <Text size={isHistorical ? 'md' : 'lg'} fw={500}>{process?.nombre}</Text>
          </div>
          {/*!isHistorical && (
            <Badge color={isActive ? 'green' : 'gray'} variant="light">
              {isActive ? 'Activo' : 'Programado'}
            </Badge>
          )*/}
        </Group>
        <Text size={isHistorical ? 'sm' : 'md'} c="dimmed">{process.descripcion || 'Sin descripción'}</Text>
        
        <Group mt={'sm'} justify='start' wrap='nowrap' >
          <IconCalendar size={16}/>
          <Text size={isHistorical ? 'sm' : 'md'}>
            {formatDate(startDate)} – {formatDate(endDate)}
          </Text>
        </Group>

        {!isHistorical && (
          <>
            <Group >
              <IconClock size={16}/>
              <Text size="md" c="dimmed">Etapa actual:</Text>
              <Text size="md" weight={500}>{actualStage?.nombre || 'Etapa finalizada'}</Text>
            </Group>
            <Group >
                <IconGridDots size={16}/>
                <Text size="md" c="dimmed">Matriz:</Text>
              <Text size="md" weight={500}>{process?.matriz?.nombre || 'Sin matriz'}</Text>
            </Group>
          </>
        )}
      </Stack>
      
      <Button
        fullWidth
        size="sm"
        mt="xs"
        variant='filled'
        color={isHistorical ? 'gray' : '#e72166'}
        //disabled={!isActive}
        rightSection={<IconArrowRight size={18} />}
        onClick={(e) => {
          e.stopPropagation();
          onSelect(process);
        }}
      >
        Acceder al Proceso
      </Button>
    </Card>
  );
}

export default ProcessCard;
